"use client";

import { useParams } from "next/navigation";
import { normalizeMonarchLocale } from "@/lib/monarch/normalizeMonarchLocale";

const LOCALE_SEGMENT_NAME = "locale";

export function getDocumentMonarchLocale(): string {
  if (typeof document === "undefined") {
    return normalizeMonarchLocale(undefined);
  }

  const lang = document.documentElement.lang;
  if (!lang) {
    return normalizeMonarchLocale(undefined);
  }

  return normalizeMonarchLocale(lang);
}

export function useMonarchLocale(): string {
  const params = useParams();
  const paramLocale = params?.[LOCALE_SEGMENT_NAME];

  if (typeof paramLocale === "string") {
    return normalizeMonarchLocale(paramLocale);
  }

  return getDocumentMonarchLocale();
}
